import { Root } from '@amcharts/amcharts5';
import {
  AxisRenderer,
  CategoryAxis,
  ColumnSeries,
  ValueAxis,
  XYChart,
} from '@amcharts/amcharts5/xy';
import { renderToString } from 'react-dom/server';

import FrameHealthTooltip from 'features/Health/components/FrameHealthChart/components/FrameHealthTooltip/FrameHealthTooltip';
import { frameHealthStatusValues } from 'features/Health/components/FrameHealthChart/utils/frameHealthStatusValues';
import { columnSeriesSettings } from 'features/Health/components/FrameHealthChart/utils/settings';
import { setTooltip } from 'features/Health/components/FrameHealthChart/utils/setTooltip';
import { FrameHealthDimension } from 'features/Health/containers/FrameHealthChartContainer/types/frameHealthDimension';
import { columnSeries } from 'utils/charts/charts';
import { FRAMES_PAGE_URL } from 'utils/defaults';

export const setSeries = (
  root: Root,
  chart: XYChart,
  frameHealthDimension: string,
  yAxis: CategoryAxis<AxisRenderer>,
  xAxis: ValueAxis<AxisRenderer>,
  data: FrameHealthDimension[]
) => {
  frameHealthStatusValues.forEach((frameHealthStatus) => {
    const series: ColumnSeries = chart.series.push(
      columnSeries(root, columnSeriesSettings(xAxis, yAxis, frameHealthStatus))
    );

    const tooltip = setTooltip(root);

    series.columns.template.setAll({
      tooltip: tooltip,
      tooltipHTML: renderToString(
        <FrameHealthTooltip
          frameHealthDimension={frameHealthDimension}
          frameHealthStatus={frameHealthStatus}
        />
      ),
    });

    series.columns.template.events.on('pointerover', () => {
      document.body.style.cursor = 'pointer';
    });

    series.columns.template.events.on('pointerout', () => {
      document.body.style.cursor = 'default';
    });

    series.columns.template.events.on('click', (ev) => {
      window.location.assign(
        `${FRAMES_PAGE_URL}?${frameHealthDimension}=${ev.target.dataItem?.dataContext?.dimension}&status=${frameHealthStatus.statusFilter}`
      );
    });

    series.data.setAll(data);
    series.appear();
  });
};
